module.exports = __webpack_public_path__ + "static/media/partner-logo3.48aeae78.png";